import { render, staticRenderFns } from "./r-map-group-dropdown.vue?vue&type=template&id=725f7a67"
import script from "./r-map-group-dropdown.vue?vue&type=script&lang=js"
export * from "./r-map-group-dropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('725f7a67')) {
      api.createRecord('725f7a67', component.options)
    } else {
      api.reload('725f7a67', component.options)
    }
    module.hot.accept("./r-map-group-dropdown.vue?vue&type=template&id=725f7a67", function () {
      api.rerender('725f7a67', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/map-group/r-map-group-dropdown.vue"
export default component.exports